import apiClient from '@/lib/api/client';

export interface NotificationItem {
  id: string;
  title: string;
  body: string;
  linkUrl: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsResponse {
  data: NotificationItem[];
  meta?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  unreadCount: number;
}

export const notificationService = {
  async list(params?: {
    unreadOnly?: boolean;
    page?: number;
    limit?: number;
  }): Promise<NotificationsResponse> {
    const response = await apiClient.get<NotificationsResponse>('/notifications', { params });
    return response.data;
  },

  async markAllRead(): Promise<void> {
    await apiClient.patch('/notifications/read-all');
  },

  async markOneRead(id: string): Promise<void> {
    await apiClient.patch(`/notifications/${id}/read`);
  },
};
